QuickSightDashboardController.$inject = ["$window", "$document", "$scope", "$state", "_", "dealerService", "reportService", "storageService"];
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.object.set-prototype-of.js";
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* injects from baggage-loader */
require('./quicksight-dashboard.component.html');
import angular from 'angular';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import './reports.scss';
import './quicksight-dashboard.component.scss';
angular.module('AaApp.Opp').component('quickSightDashboard', {
  templateUrl: '/app/components/reports/quicksight-dashboard.component.html',
  controller: QuickSightDashboardController
});

/* @ngInject */
function QuickSightDashboardController($window, $document, $scope, $state, _, dealerService, reportService, storageService) {
  var $ctrl = this;
  var selectedDealerIdsSubscription = null;
  var dashboardRenderRequestId = 0;
  $ctrl.reportsEnabled = false;
  $ctrl.reportEnabled = true;
  $ctrl.embeddingDashboard = false;
  $ctrl.selectedDashboardId = null;
  $ctrl.selectedDashboardName = '';
  $ctrl.embedError = '';
  $ctrl.statusMessageKey = '';
  $ctrl.$onInit = onInit;
  $ctrl.$onDestroy = onDestroy;
  function onInit() {
    var moduleIds = storageService.getItem('moduleIds');
    var authorizedReports = reportService.getAuthorizedReports(moduleIds);
    $ctrl.reportsEnabled = authorizedReports.length > 0;
    if (!$ctrl.reportsEnabled) {
      return;
    }
    selectedDealerIdsSubscription = dealerService.onSelectedDealersChanged(function () {
      if ($ctrl.selectedDashboardId) {
        renderSelectedDashboard($ctrl.selectedDashboardId);
      }
    });
    var initialDashboardId = getDashboardIdFromState();
    if (!initialDashboardId) {
      $ctrl.reportEnabled = false;
      $ctrl.statusMessageKey = 'quickSightSelectReport';
      return;
    }
    $ctrl.selectedDashboardId = initialDashboardId;
    $ctrl.selectedDashboardName = getDashboardNameFromState() || initialDashboardId;
    renderSelectedDashboard(initialDashboardId);
  }
  function onDestroy() {
    if (selectedDealerIdsSubscription && selectedDealerIdsSubscription.unsubscribe) {
      selectedDealerIdsSubscription.unsubscribe();
    }
  }
  function getDashboardIdFromState() {
    if ($state && $state.params) {
      return $state.params.dashboardId || $state.params.id || '';
    }
    return '';
  }
  function getDashboardNameFromState() {
    if ($state && $state.params) {
      return $state.params.reportName || '';
    }
    return '';
  }
  function renderSelectedDashboard(_x) {
    return _renderSelectedDashboard.apply(this, arguments);
  }
  function _renderSelectedDashboard() {
    _renderSelectedDashboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dashboardId) {
      var requestId, selectedDealerIds, selectedDealerIdList, reportUrl, results, embedUrl, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            requestId = ++dashboardRenderRequestId;
            $ctrl.embeddingDashboard = true;
            $ctrl.embedError = '';
            $ctrl.statusMessageKey = '';
            _context.p = 1;
            selectedDealerIds = dealerService.getSelectedDealerIds() || [];
            selectedDealerIdList = selectedDealerIds.join(',');
            reportUrl = buildReportUrl(dashboardId);
            _context.n = 2;
            return reportService.getQuickSightEmbedUrl(dashboardId, selectedDealerIdList);
          case 2:
            results = _context.v;
            if (!(requestId !== dashboardRenderRequestId)) {
              _context.n = 3;
              break;
            }
            return _context.a(2);
          case 3:
            if (!(!results || results.Success !== true || !results.Data)) {
              _context.n = 4;
              break;
            }
            throw new Error(getQuickSightResponseMessage(results));
          case 4:
            embedUrl = getQuickSightEmbedUrlValue(results.Data);
            if (embedUrl) {
              _context.n = 5;
              break;
            }
            throw new Error(getQuickSightResponseMessage(results));
          case 5:
            _context.n = 6;
            return embedDashboard(embedUrl, buildQuickSightParameters(results, reportUrl));
          case 6:
            _context.n = 9;
            break;
          case 7:
            _context.p = 7;
            _t = _context.v;
            if (!(requestId !== dashboardRenderRequestId)) {
              _context.n = 8;
              break;
            }
            return _context.a(2);
          case 8:
            $ctrl.embedError = getQuickSightErrorMessage(_t);
            if (!$ctrl.embedError) {
              $ctrl.statusMessageKey = 'quickSightLoadError';
            }
          case 9:
            _context.p = 9;
            if (requestId === dashboardRenderRequestId) {
              $ctrl.embeddingDashboard = false;
            }
            return _context.f(9);
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[1, 7, 9, 10]]);
    }));
    return _renderSelectedDashboard.apply(this, arguments);
  }
  function embedDashboard(_x2, _x3) {
    return _embedDashboard.apply(this, arguments);
  }
  function _embedDashboard() {
    _embedDashboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(embedUrl, parameters) {
      var embeddingContext, embedHeight, container;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return createEmbeddingContext();
          case 1:
            embeddingContext = _context2.v;
            embedHeight = getEmbedHeight();
            container = $document[0].getElementById('quicksight-embed-container');
            if (container) {
              container.innerHTML = '';
              container.style.height = embedHeight;
            }
            _context2.n = 2;
            return embeddingContext.embedDashboard({
              url: embedUrl,
              container: '#quicksight-embed-container',
              height: embedHeight,
              width: '100%'
            }, {
              locale: 'en-US',
              parameters: parameters,
              onMessage: function onMessage(messageEvent) {
                if (messageEvent && messageEvent.eventName === 'ERROR_OCCURRED') {
                  $scope.$applyAsync(function () {
                    var errorCode = messageEvent.message && messageEvent.message.errorCode;
                    $ctrl.embedError = errorCode ? 'QuickSight error: ' + errorCode : 'QuickSight reported an error while loading the report.';
                    $ctrl.statusMessageKey = '';
                  });
                }
              },
              toolbarOptions: {
                export: true,
                undoRedo: true,
                reset: true,
                bookmarks: true,
                thresholdAlerts: false,
                scheduling: true,
                recentSnapshots: false,
                executiveSummary: false
              }
            });
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _embedDashboard.apply(this, arguments);
  }
  function getEmbedHeight() {
    var viewportHeight = $window.innerHeight || 900;
    return Math.max(viewportHeight - 180, 1400) + 'px';
  }
  function buildReportUrl(dashboardId) {
    return $window.location.host + '/reports/quickSightReports?id=' + encodeURIComponent(dashboardId);
  }
  function buildQuickSightParameters(results, reportUrl) {
    var userProfile = storageService.getItem('userProfile') || {};
    var data = results && results.Data && _typeof(results.Data) === 'object' ? results.Data : {};
    var platformIdsValue = data.selectedAutoAlertPlatformIds != null ? data.selectedAutoAlertPlatformIds : data.SelectedAutoAlertPlatformIds;
    var platformIds = toQuickSightValues(platformIdsValue);
    var primaryRoleId = data.primaryRoleId != null ? data.primaryRoleId : data.PrimaryRoleId != null ? data.PrimaryRoleId : userProfile.roleId;
    var packages = toQuickSightValues(data.selectedAutoAlertDealerPackages || data.SelectedAutoAlertDealerPackages);
    if (platformIdsValue == null && angular.isArray(userProfile.accountPlatformIds)) {
      platformIds.push.apply(platformIds, _toConsumableArray(userProfile.accountPlatformIds.map(String)));
    }
    return [{
      Name: 'selectedAutoAlertPlatformIds',
      Values: platformIds
    }, {
      Name: 'primaryRoleId',
      Values: primaryRoleId == null ? [] : [String(primaryRoleId)]
    }, {
      Name: 'selectedAutoAlertDealerPackages',
      Values: packages.map(String)
    }, {
      Name: 'reportUrl',
      Values: [reportUrl]
    }];
  }
  function toQuickSightValues(value) {
    if (angular.isArray(value)) {
      return value.map(String);
    }
    if (typeof value === 'string') {
      return value.split('|').filter(function (item) {
        return item !== '';
      }).map(String);
    }
    if (value == null) {
      return [];
    }
    return [String(value)];
  }
  function getQuickSightResponseMessage(results) {
    if (!results) {
      return '';
    }
    return coerceQuickSightMessage(results.Message) || coerceQuickSightMessage(results.message) || coerceQuickSightMessage(results.Messages) || coerceQuickSightMessage(results.messages) || coerceQuickSightMessage(results.Details) || '';
  }
  function getQuickSightEmbedUrlValue(data) {
    if (!data) {
      return '';
    }
    if (typeof data === 'string') {
      return data;
    }
    if (_typeof(data) === 'object') {
      return data.Url || data.url || data.EmbededUrl || data.embededUrl || data.EmbedUrl || data.embedUrl || data.Value || data.value || coerceQuickSightMessage(data.Data) || '';
    }
    return coerceQuickSightMessage(data);
  }
  function getQuickSightErrorMessage(error) {
    if (!error) {
      return '';
    }
    if (error.message) {
      return error.message;
    }
    if (error.body) {
      return getQuickSightResponseMessage(error.body);
    }
    if (error.error) {
      return getQuickSightResponseMessage(error.error);
    }
    if (error.data) {
      return getQuickSightResponseMessage(error.data);
    }
    return getQuickSightResponseMessage(error);
  }
  function coerceQuickSightMessage(value) {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
      return String(value);
    }
    if (angular.isArray(value)) {
      for (var i = 0; i < value.length; i++) {
        var itemMessage = coerceQuickSightMessage(value[i]);
        if (itemMessage) {
          return itemMessage;
        }
      }
      return '';
    }
    if (_typeof(value) === 'object') {
      return coerceQuickSightMessage(value.Message) || coerceQuickSightMessage(value.message) || coerceQuickSightMessage(value.ErrorMessage) || coerceQuickSightMessage(value.errorMessage) || coerceQuickSightMessage(value.Messages) || coerceQuickSightMessage(value.messages) || coerceQuickSightMessage(value.Details) || coerceQuickSightMessage(value.detail) || '';
    }
    return String(value);
  }
}